import { render, staticRenderFns } from "./AppBtnStyle3.vue?vue&type=template&id=10b2e350&scoped=true&"
import script from "./AppBtnStyle3.vue?vue&type=script&lang=js&"
export * from "./AppBtnStyle3.vue?vue&type=script&lang=js&"
import style0 from "./AppBtnStyle3.vue?vue&type=style&index=0&id=10b2e350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2e350",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
